var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSigTaskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 54,
    viewBox: "0 0 66 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.6712 42.5499V52.7041H1V1.4115H44.6712V12.8648",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 6H40",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 10H40",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16H41",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 20H41",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 25H41",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6 30H39",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.61133 16V29.7",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8032 16V29.7",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41 16L41 28",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8032 33.6338H29.6794",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5232 46.4309L32.5075 36.8949L53.7283 15.862L59.5469 10.0952L64.3755 14.6828L37.1564 42.2055L28.5232 46.4309Z",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1568 42.2059L32.5066 36.8939",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0002 12.6199L55.6194 11.2296C55.136 10.7435 54.353 10.7367 53.8628 11.2133L45.5442 19.2881",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5209 20.1152L53.9688 15.6243",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30997 44.2111C8.47371 42.2898 9.52767 41.6784 12.0209 40.2091C12.3151 41.3666 12.3028 42.6016 11.9842 43.7536C11.6478 44.9642 10.8771 46.1597 9.67746 46.5356C9.49771 46.5914 9.28665 46.6227 9.1355 46.5124C8.95167 46.3776 8.94758 46.108 8.97618 45.882C9.19678 44.1785 10.3556 42.6275 11.927 41.933C12.4458 41.7043 13.0708 41.5722 13.561 41.8568C14.0512 42.1414 14.1779 42.987 13.6727 43.2416C14.5265 42.3225 15.5886 41.5994 16.7569 41.1432C16.87 41.7056 16.8536 42.2925 16.712 42.8494C17.2608 42.5036 17.8095 42.1577 18.3583 41.8118C18.4618 42.2557 18.5653 42.6997 18.6688 43.1436C19.2216 42.7201 19.6383 42.1223 19.8466 41.4578C19.72 41.9834 19.5934 42.509 19.4667 43.0346C20.5779 43.0755 21.6877 42.4328 22.2051 41.4469C21.8511 41.8813 21.8116 42.5431 22.1125 43.0156C22.4121 43.4881 23.0289 43.7332 23.5723 43.597C23.8187 43.5344 24.0747 43.2321 23.8841 43.0632C23.5845 43.2198 23.2836 43.3764 22.9826 43.5317",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigTaskIcon);
export default __webpack_public_path__ + "static/media/sig_task_icon.b7a2cd357b10c4e12b2c9dfc86a12c06.svg";
export { ForwardRef as ReactComponent };